import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { EnvelopeSimple, MapPin, Phone } from "@phosphor-icons/react";

export const ShopFooter = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <footer className="mt-16 bg-[#2e3a47] text-white/80">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4">
        <div>
          <img src="/logo-servitech.png" alt="Servitech Xpert" className="mb-4 h-14 w-auto" />
          <p className="text-xs leading-relaxed">{t.footerAbout}</p>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-bold uppercase tracking-wide text-white">{t.myAccount}</h4>
          <ul className="space-y-2 text-xs">
            <li><button onClick={() => navigate("/login")} className="hover:text-white">{t.signIn}</button></li>
            <li><button onClick={() => navigate("/login")} className="hover:text-white">{t.register}</button></li>
            <li><button onClick={() => navigate("/shop")} className="hover:text-white">{t.allProducts}</button></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-bold uppercase tracking-wide text-white">{t.navigation}</h4>
          <ul className="space-y-2 text-xs">
            <li><button onClick={() => navigate("/")} className="hover:text-white">{t.home}</button></li>
            <li><button onClick={() => navigate("/catalogue")} className="hover:text-white">{t.catalog}</button></li>
            <li><button onClick={() => navigate("/apropos-fr")} className="hover:text-white">{t.aboutCompany}</button></li>
            <li><button onClick={() => navigate("/contactez-nous")} className="hover:text-white">{t.contact}</button></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-bold uppercase tracking-wide text-white">{t.contact}</h4>
          <ul className="space-y-2 text-xs">
            <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5" /> C.P. 2 Saint-Constant, QC J5A 2G1</li>
            <li className="flex items-center gap-2"><Phone size={15} /> 514-475-8974</li>
            <li className="flex items-center gap-2"><EnvelopeSimple size={15} /> commandes@servitechxpert.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1280px] px-4 py-4 text-center text-[11px] text-white/50">
          © 2024–2026 ServitechXpert. {t.rightsReserved}
        </div>
      </div>
    </footer>
  );
};
